import { NewUser } from "../pages/signup/model";
import { LoginUser } from "../pages/login/model";
import {
    ForgotPasswordSendCode,
    ConfirmChangeForgottenPassword,
} from "../pages/forgotPassword/model";
import { api } from "../adapters/api";

const resource = "api/v1";

const extractErrorMessage = async (response: Response): Promise<string> => {
    try {
        const data = await response.json();
        return data["error-message"] ?? "A apărut o eroare. Încearcă din nou.";
    } catch {
        return "A apărut o eroare. Încearcă din nou.";
    }
};

export const signup = async (user: NewUser): Promise<void> => {
    const response = await api.post(`${resource}/auth/register-employer`, user);

    if (!response.ok) {
        const message = await extractErrorMessage(response);
        throw new Error(message);
    }
};

export const login = async (user: LoginUser): Promise<{ token: string }> => {
    const response = await api.post(`${resource}/auth/login-employer`, user);

    if (!response.ok) {
        const message = await extractErrorMessage(response);
        throw new Error(message);
    }

    const text = await response.text();
    return text ? JSON.parse(text) : ({} as { token: string });
};

export const verifyEmail = async (code: string): Promise<{ token: string }> => {
    const response = await api.post(`${resource}/auth/verify-email`, { code });

    if (!response.ok) {
        const message = await extractErrorMessage(response);
        throw new Error(message);
    }

    const data = await response.json();

    if (!data.token) {
        throw new Error("Token lipsă după verificare.");
    }

    return data;
};

export const resendVerificationEmail = async (email: string): Promise<void> => {
    const response = await api.post(`${resource}/auth/resend-verification-email`, {
        email,
    });

    if (!response.ok) {
        const message = await extractErrorMessage(response);
        throw new Error(message);
    }
};

export const getCities = async () => {
    const response = await api.get(`${resource}/cities`);

    if (!response.ok) {
        throw new Error("Nu s-au putut încărca orașele.");
    }

    return response.json();
};

export const getCounties = async () => {
    const response = await api.get(`${resource}/counties`);

    if (!response.ok) {
        throw new Error("Nu s-au putut încărca județele.");
    }

    return response.json();
};

export const getCitiesByCounty = async (countyCode: string) => {
    const response = await api.get(`${resource}/cities?county=${encodeURIComponent(countyCode)}`);

    if (!response.ok) {
        throw new Error("Nu s-au putut încărca localitățile.");
    }

    return response.json();
};

export const searchCities = async (query: string) => {
    const response = await api.get(`${resource}/cities?search=${encodeURIComponent(query)}`);

    if (!response.ok) {
        throw new Error("Nu s-au putut căuta orașele.");
    }

    return response.json();
};

export const sendResetCode = async (user: ForgotPasswordSendCode) => {
    const response = await api.post(`${resource}/employer/request-reset-password`, user);

    if (!response.ok) {
        const message = await extractErrorMessage(response);
        throw new Error(message);
    }

    const text = await response.text();
    return text ? JSON.parse(text) : {};
};

export const confirmPasswordReset = async (
    user: ConfirmChangeForgottenPassword
) => {
    const response = await api.post(`${resource}/employer/reset-password`, user);

    if (!response.ok) {
        const message = await extractErrorMessage(response);
        throw new Error(message);
    }

    const text = await response.text();
    return text ? JSON.parse(text) : {};
};